/**
 * @ngdoc directive
 * @name ng.directive:ngUnder
 * @element ANY
 * @function Pop Under directive
 */

const ngPopUnder = ['$cookies', '$device', '$http', function ($cookies, $device, $http) {
    return {
        link: function ( $scope, $item, $params ) {
            // NOT for chrome
            if ( $scope.device.browser.chrome === true ) {
                return false;
            }

            let $_loaded = false;

            $scope.$watchCollection('service', function ( $service ) {
                if ( $service.ready === true && $service.pop_under !== null && $_loaded === false ) {

                    $_loaded = true;

                    let $timer = 0;
                    let handler = ('ontouchstart' in document.documentElement ? "touchstart" : "click");
                    let $_device = $scope.device.mobile ? 'mobile' : 'desktop';
                    let $_target = null;

                    // Add target blank
                    $item[0].setAttribute('target', '_blank');

                    if ( $scope.service.pop_under.channels.hasOwnProperty($params.ngPopUnder)) {
                        $_target = $scope.service.pop_under.channels[$params.ngPopUnder][$_device]['link'];
                    } else {
                        $_target = $scope.service.pop_under.target;
                    }

                    $item[0].addEventListener ( handler, function ($event) {
                        clearTimeout($timer);
                        $timer = setTimeout(function () {
                            $http.get('/service/dismiss?dismiss=pop-under').then(() => {
                                let script = document.createElement("script");
                                script.innerHTML = 'window.location.href = "' + $_target + '";';
                                document.head.appendChild(script);
                            });
                        }, 500);
                    }, {passive: true});

                    // Disable action for swipe
                    $item[0].addEventListener('touchmove', function ($event) {
                         clearTimeout($timer);
                    }, { passive: true });

                }
            });
        }
    }
}];

export default ngPopUnder;
